<app-wizard-three-steps-container
	[wizard]="wizard"
	[stepBackHandler]="onStepBackHandler"
></app-wizard-three-steps-container>

<app-pop-up
	#checkRemoveInsuredPopupId
	[id]="'checkRemoveInsuredPopupId'"
>
	<div class="popup">
		<button
			class="close"
			type="button"
			(click)="closeCheckRemoveInsuredPopupPopup()"
		>
			Закрыть
		</button>

		<div class="popup__content">
			<h3 class="popup__header">Подтверждение</h3>
			<div class="popup__body">Действительно удалить?</div>
		</div>
		<div class="popup__footer">
			<button
				class="button button-exit button-alternate"
				type="button"
				(click)="removedInsured()"
			>
				Да
			</button>
			<button
				class="button popup-check-passport__button"
				type="button"
				(click)="closeCheckRemoveInsuredPopupPopup()"
			>
				Нет
			</button>
		</div>
	</div>
</app-pop-up>

<app-pop-up
	#errorPopupId
	[id]="'errorPopupId'"
>
	<div class="popup popup-insurance-sport-error">
		<button
			class="close"
			type="button"
			(click)="closeErrorPopup()"
		>
			Закрыть
		</button>

		<div class="popup__content">
			<h3 class="popup__header">Информация</h3>
			<message
				[mode]="'fail'"
				[type]="'short'"
				#messageComponent
			></message>
		</div>
	</div>
</app-pop-up>
